import moment from "moment";
import { Badge } from "src/components/ui/Badge";


const leaveTypeStyles: Record<
  string,
  {
    bg: string;
    border: string;
    icon: string;
    badge: string;
    dot: string;
    label: string;
    text: string;
  }
> = {
  SL: {
    bg: "bg-stone-50/70",
    border: "border-stone-200",
    icon: "bg-stone-100 text-stone-700",
    badge: "bg-stone-100 text-stone-700",
    text: "text-stone-700",
    dot: "bg-stone-500",
    label: "Sick Leave",
  },

  CL: {
    bg: "bg-fuchsia-50/70",
    border: "border-fuchsia-200",
    icon: "bg-fuchsia-100 text-fuchsia-700",
    badge: "bg-fuchsia-100 text-fuchsia-700",
    text: "text-fuchsia-700",
    dot: "bg-fuchsia-500",
    label: "Casual Leave",
  },

  PLL: {
    bg: "bg-cyan-50/70",
    border: "border-cyan-200",
    icon: "bg-cyan-100 text-cyan-700",
    badge: "bg-cyan-100 text-cyan-700",
    text: "text-cyan-700",
    dot: "bg-cyan-500",
    label: "Planned Leave",
  },

  MTL: {
    bg: "bg-pink-50/70",
    border: "border-pink-200",
    icon: "bg-pink-100 text-pink-700",
    badge: "bg-pink-100 text-pink-700",
    text: "text-pink-700",
    dot: "bg-pink-500",
    label: "Maternity Leave",
  },

  PTL: {
    bg: "bg-indigo-50/70",
    border: "border-indigo-200",
    icon: "bg-indigo-100 text-indigo-700",
    badge: "bg-indigo-100 text-indigo-700",
    text: "text-indigo-700",
    dot: "bg-indigo-500",
    label: "Paternity Leave",
  },

  LWP: {
    bg: "bg-orange-50/80",
    border: "border-orange-200",
    icon: "bg-orange-200 text-orange-700",
    badge: "bg-orange-200 text-orange-700",
    text: "text-orange-700",
    dot: "bg-orange-500",
    label: "Leave Without Pay",
  },
};

const LeaveCalendarCard = ({ leaveDay, date }: { leaveDay: string; date?: Date }) => {
  const leaveStyle = leaveTypeStyles[leaveDay] ?? leaveTypeStyles.CL;

  return (
    <div
      className={`
      w-full max-w-md mt-3 flex items-center justify-between
      gap-8 rounded-2xl border p-4
      backdrop-blur-md
      transition-all duration-200
      ${leaveStyle.bg}
      ${leaveStyle.border}
    `}
    >
      <div className="flex items-center gap-3">
        {/* Icon */}
        <div
          className={`
          flex h-10 w-10 shrink-0
          items-center justify-center
          rounded-xl
          ${leaveStyle.icon}
        `}
        >
          <span className={`h-2.5 w-2.5 rounded-full ${leaveStyle.dot}`} />
        </div>

        {/* Leave information */}
        <div>
          <p className="text-sm text-muted">
            {date ? moment(date).format("Do MMM YYYY") : "--"}
          </p>
          <p className={`text-md font-semibold ${leaveStyle.text}`}>
            {leaveStyle.label}
          </p>
        </div>
      </div>

      {/* Status */}
      <Badge
        className={`
        rounded-full border-0
        px-3 py-1
        text-xs font-medium
        ${leaveStyle.badge}
      `}
      >
        Leave
      </Badge>
    </div>
  );
};

export default LeaveCalendarCard;
